let IntegrationType = /*#__PURE__*/function (IntegrationType) {
  IntegrationType["FRONTEND_CONFIGURED"] = "FRONTEND_CONFIGURED";
  IntegrationType["ONBOARDING_PACKLINK"] = "ONBOARDING_PACKLINK";
  IntegrationType["ONBOARDING_PARTNER"] = "ONBOARDING_PARTNER";
  IntegrationType["MODULE"] = "MODULE";
  return IntegrationType;
}({});

export { IntegrationType };
//# sourceMappingURL=Integration.js.map
